type SimpleFormatterOptions = {
  digits?: number;
  includeCurrency?: boolean;
};

// fixed locale, use the useNumberFormatter hook (where possible) to take this into account
// mostly for legacy (or BFF) use
const formatAsCurrency = (number: number, options?: SimpleFormatterOptions) => {
  const { digits = 2, includeCurrency = true } = options ?? {};

  const numberFormatterOptions: Intl.NumberFormatOptions = {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  };

  if (includeCurrency) {
    numberFormatterOptions.currency = 'EUR';
    numberFormatterOptions.style = 'currency';
  }

  return new Intl.NumberFormat('nl-BE', numberFormatterOptions).format(number);
};

const toPercentage = (value: number) => Number((value * 100).toFixed(2));

export { formatAsCurrency, toPercentage };
